import { render } from "./ChatMediaUploadButton.vue?vue&type=template&id=709d8dde"
import script from "./ChatMediaUploadButton.vue?vue&type=script&lang=js"
export * from "./ChatMediaUploadButton.vue?vue&type=script&lang=js"
script.render = render

export default script